<template>
  <VImg
    id="id"
    :src="src"
    v-bind="$props"
  >
    <slot />
  </VImg>
</template>

<script>
export default {
    name: "PsImage",
    props: {
        id: {
            type: String,
            required: true
        },
        src: {
            type: String,
            required: true
        }
    }
};
</script>
